import React from 'react';

import { flagStyles } from '../settings';

const SvgYT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5832px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgYT;
